import {Component, EventEmitter, Input, Output} from '@angular/core';
import {appointmentAssistanceTypeName} from '@shared/constants/appointment.constants';

@Component({
  selector: 'si-appo-attendance-confirm-button',
  templateUrl: './appo-attendance-confirm-button.component.html',
  styleUrls: ['./appo-attendance-confirm-button.component.scss']
})
export class AppoAttendanceConfirmButtonComponent {
  @Input() appoId: number;
  @Input() serviceName: string;
  @Input() startDate: number;
  @Input() assistanceTypeCode: boolean;
  @Output() appoAttendanceConfirmed = new EventEmitter<any>();
  displayConfirmAttendanceDialog: boolean;
  appointmentAssistanceTypeName = appointmentAssistanceTypeName;

  onClickConfirmButton(): void {
    event.stopPropagation();
    event.preventDefault();
    this.displayConfirmAttendanceDialog = true;
  }

  onConfirmAttendance(): void {
    this.appoAttendanceConfirmed.emit();
  }
}
